/* @flow */
import * as React from 'react';
import styles from './styles.module.scss';

type Props = {
  children?: any,
};

export default (props: Props): React$Element<any> => {
  const { children } = props;
  return <div className={styles.toolbar}>{children}</div>;
};
